<template>
  <div style="height: 100%">
    <RegisterContainer
      style="height: 100%"
      :contentStyle="{ height: '100%', position: 'relative' }"
    >
      <div
        style="
          margin: auto;

          position: absolute;
          inset: 0;

          max-height: 100%;

          margin: auto;
          height: fit-content;
          width: fit-content;
          background-color: var(--v-background-base);
          z-index: 1;
        "
        class="pa-2 text-center flex-grow-1"
      >
        <TruformeLoader>
          <div>Processing...</div>
          <div style="font-size: 0.7rem">This may take a few moments</div>
        </TruformeLoader>
      </div>
    </RegisterContainer>
  </div>
</template>

<script>
import TruformeLoader from '../components/Truforme/TruformeLoader.vue';
import RegisterContainer from '../components/RegisterContainer.vue';

export default {
  name: 'RegisterComplete',
  props: {
    customLogo: String,
  },
  components: { RegisterContainer, TruformeLoader },
  data() {
    return {
      nextRoute: null,
      showDialog: true,
      thankyouDialog: true,
      /* tenant customizable options */
      buttonText: this.$t('registration.registerComplete.buttonText'),
      clickToContinue: true,
      cardText: this.$t('registration.registerComplete.cardText'),
      cardTitle: this.$t('registration.registerComplete.cardTitle'),
      loadingText: null,
      loadingTitleText: null,
      init: null,
      /* should the store be reset after this component completes */
      isEndOfRegistration: true,
      checkForExistingUser: false,
      sendNotification: true,
      onSuccess: () => {},
    };
  },

  computed: {
    isComplete() {
      return this.nextRoute;
    },
    memberId() {
      return this.$store.state.registration.memberId;
    },
    saveText() {
      return this.$store.state.registration.saveText;
    },
    loadingValue() {
      return this.$store.state.loadingValue;
    },
  },
  methods: {
    async completeRegistration() {
      const { checkForExistingUser } = this;
      await this.$store.dispatch('completeRegistration', {
        memberInfo: { email: this.$store.state.registration.patientData.email, password: null },
        currentRoute: this.$route.name,
        isEndOfRegistration: this.isEndOfRegistration,
        checkForExistingUser,
        sendNotification: this.sendNotification,
        setToken: !this.isEmbedded,
      });

      const { memberId } = this.$store.state.registration;
      if (memberId) this.onComplete();
    },
    getInitialState() {
      const config = this.$store.getters.getConfig(this.$options.name);
      if (!config) return;
      Object.keys(config).forEach((option) => {
        this[option] = config[option];
      });
    },
    onComplete() {
      /*
                                                                                                                                                                    TODO: eliminate isPageFlowV2 check once we have
                                                                                                                                                                    fully migrated over to pageflow 2.0 system
                                                                                                                                                                  */
      this.$store.commit('set', { loadingValue: 0 });
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    },
    setAttributes() {
      const { att } = this.$route.query;
      if (!att) return;
      const attributes = att.split('-');

      const currentAttributes = this.$store.state.registration.memberAttributes;
      const memberAttributes = [
        ...(Array.isArray(currentAttributes) ? currentAttributes : []),
        ...attributes,
      ];

      this.$store.commit('setRegistration', {
        memberAttributes,
      });
    },
  },
  async mounted() {
    if (!this.isPageflowV2) {
      this.getInitialState();

      this.$store.watch(
        (state) => state.registration.errors.registerError,
        (value) => {
          if (value) {
            this.$router.push({ name: this.$store.getters.previousFlowRoute(this.$route.name) });
          }
        }
      );
    }
    this.setAttributes();
    this.$store.commit('setRegistration', { errors: { registerError: false } });

    this.$nextTick(async () => {
      await this.completeRegistration();
    });
  },
};
</script>
